export default __webpack_public_path__ + "static/media/deadboy_002.ea957b45.jpg";